import { render } from "./TopicFeed.vue.js?vue&type=template&id=0266ca71&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicFeed.vue?vue&type=template&id=0266ca71&scoped=true"
import script from "./TopicFeed.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicFeed.vue?vue&type=script&lang=js"
export * from "./TopicFeed.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicFeed.vue?vue&type=script&lang=js"

import "./TopicFeed.vue.css?vue&type=style&index=0&id=0266ca71&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicFeed.vue?vue&type=style&index=0&id=0266ca71&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0266ca71"],['__file',"src/Web/scripts/pages/community/TopicFeed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0266ca71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0266ca71', __exports__)) {
    api.reload('0266ca71', __exports__)
  }
  
  module.hot.accept("./TopicFeed.vue.js?vue&type=template&id=0266ca71&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicFeed.vue?vue&type=template&id=0266ca71&scoped=true", () => {
    api.rerender('0266ca71', render)
  })

}


export default __exports__